import { Props } from '@/pages/platform/shop-detail'
import useIsMobile from '@/hooks/useIsMobile'
import dynamic from 'next/dynamic'

const PC = dynamic(() => import('@/pages/platform/shop-detail'))
const Mobile = dynamic(() => import('@/mobile-pages/shop-detail'))

const ShopDetail = (props: Props) => {
  return useIsMobile() ? <Mobile {...props} /> : <PC {...props} />
}

export { getServerSideProps } from '@/pages/platform/shop-detail'

export default ShopDetail
